import { openModal } from '@core/components/ModalStack';
import { ResendProposalModalProps } from './ResendProposalModal';

export async function openResendProposal(props: ResendProposalModalProps) {
  const { ResendProposalModal } = await import('./ResendProposalModal');

  openModal(ResendProposalModal, props);
}
